// @core/api/endpoints/analytics/duplicate_dashboard.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DashboardResponse,
  DuplicateDashboardRequest,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Duplicate dashboard
 * Creates a copy of a dashboard with all widgets. The copy is set to private visibility.
 */
export async function DuplicateDashboard(
  dashboard_id: string,
  data: DuplicateDashboardRequest,
  options?: RequestOptions
): Promise<DashboardResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/dashboards/:dashboard_id/duplicate`;
  requestPath = requestPath.replace(':dashboard_id', encodeURIComponent(dashboard_id));
  const requestOptions = options;
  return client.post<DashboardResponse>(requestPath, data, requestOptions);
}
